export function isGamesActive() {
  return process.env.REACT_APP_ACTIVE === 'true'
}
